import { TaskInput } from '../../types'
import {
  GreyGrey60,
  GreyGrey80,
  GreyGrey90,
  Primary13Regular,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'

export const QuoteReviewDiscussion = (props: { taskInput: TaskInput }) => {
  return (
    <Flex flexDirection="column" gap="16px" padding="16px">
      <Box {...Primary13SemiBold} color={GreyGrey80}>
        {props.taskInput.requestor.email} commented:
      </Box>
      {props.taskInput.comment ? (
        <Box {...Primary13Regular} color={GreyGrey90} whiteSpace="pre-wrap">
          {props.taskInput.comment}
        </Box>
      ) : (
        <Box {...Primary13Regular} color={GreyGrey60} whiteSpace="pre-wrap">
          No comment provided
        </Box>
      )}
    </Flex>
  )
}
